import { clsx } from '@payaca/utilities/cvaMerge';
import { FC, PropsWithChildren } from 'react';

type Props = {
  className?: string;
};
const CompanySettingsTabBase: FC<PropsWithChildren<Props>> = (props) => {
  const { children, className } = props;
  return (
    <div
      className={clsx(
        'flex flex-col gap-y-4 w-full max-w-screen-xl m-auto',
        className
      )}
    >
      {children}
    </div>
  );
};

export default CompanySettingsTabBase;
